export const NEW_LIST_PREFIX = "New Watchword List";

export const ERROR_TITLE =
  "There was a problem taking action on this Watchwords List.";
